import { SkeletonLoading } from 'app/common/templates-next/page-template'


export const TableLoading = () => {
  return (
    <SkeletonLoading />
  )
}
